export const updateLanguage = ({ BeURL, topInput, showAlert, setLanguage, editingCardId, handleTopClear }) => {
    fetch(`${BeURL}/language/${editingCardId}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ topInput }),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                setLanguage(data.languages)
                handleTopClear()
            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in update language", err);
        });
}
